export default __webpack_public_path__ + "public/images/home/intro/blueStar.png?75c6e278";